import './style.scss';
import './style.darkmode.scss';

import { useState, useEffect } from 'react';
import PuSearch from './pu-search';
import PuLookup from './pu-lookup';
import ReactDatePicker from 'react-datepicker';
import DecimalInput from '../../common/DecimalInput';
import SuList from './su-list';
import PAlert from '../../common/PAlert';
import { captureMessage } from '@sentry/react';
import { useToasts } from "react-toast-notifications";
import MainList from './main-list';
import SuLookup from './su-lookup';
import Papa from 'papaparse';
import AddOptions from './add-options';
import { toFixedTrunc } from '../../utils/helper';

const CreatorSalesBoost = () => {
    const { addToast } = useToasts();

    const [selectedPus, setSelectedPus] = useState([]);
    const [selectedSus, setSelectedSus] = useState([]);
    const [selectedPusError, setSelectedPusError] = useState('');
    const [selectedSusError, setSelectedSusError] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const [fromRange, setFromRange] = useState('');
    const [toRange, setToRange] = useState('');
    const [refetch, setRefetch] = useState(0);
    const [spend, setSpend] = useState('');
    const [isBusy, setIsBusy] = useState(false);
    const [exportCSV, setExportCSV] = useState(false);
    const [excluded, setExcluded] = useState('');
    const [status, setStatus] = useState(0);
    const [puFollowersToInclude, setPuFollowersToInclude] = useState([]);
    const [suToInclude, setSuToInclude] = useState([]);
    const [selectedSUsObject, setSelectedSUsObject] = useState([]);
    const [mainList, setMainList] = useState([]);
    const [suToAdd, setSuToAdd] = useState([]);
    const [evalMainList, setEvalMainList] = useState(0);
    const [removeCount, setRemoveCount] = useState(0);
    const [firstSubscription, setFirstSubscription] = useState('');
    const [subscriptionPrice, setSubscriptionPrice] = useState('');
    const [planName, setPlanName] = useState('');

    const handleAddFollowers = () => {
        if (selectedPus.length <= 0) {
            setSelectedPusError('Creator is required');
            return;
        }

        if (suToAdd && suToAdd.length <= 0) {
            setSelectedSusError('Please select at least 1 SU');
            setShowAlert(true);
            return;
        }

        if (status == 'recurring') {
            if (parseFloat(subscriptionPrice) <= 0) {
                setSelectedSusError('Please enter a valid subscription price');
                setShowAlert(true);
                return;
            }

            if (planName.length <= 0) {
                setSelectedSusError('Please enter a valid subscription plan name');
                setShowAlert(true);
                return;
            }
        }

        setIsAdding(true);
        axios.post('/api/administration/creator-sales-boost', {
            pus: selectedPus,
            sus: [...new Set(suToAdd)],
            status,
            subscription_price: subscriptionPrice,
            plan_name: planName
        })
            .then(response => {
                setIsAdding(false);
                setSuToAdd([]);

                setSelectedSusError('New followers are now queued');
                setShowAlert(true);
                setEvalMainList(true);
            })
            .catch(error => {
                if (error.response.status === 422) {
                    const responseData = error.response.data;
                    const firstErrorKey = Object.keys(responseData.errors);
                    setSelectedSusError(responseData.errors[firstErrorKey[0]]);
                    setShowAlert(true);
                } else {
                    addToast('Failed to add new followers', { appearance: 'error', autoDismiss: true });
                }
                setIsAdding(false);
            });
    };

    const handleCloseAlert = () => {
        setSelectedSusError('');
    };

    useEffect(() => {
        if (selectedPus.length > 0) {
            setSelectedPusError('');
        }
    }, [selectedPus]);

    useEffect(() => {
        if (selectedSus.length > 0) {
            setSelectedSusError('');
            setShowAlert(false);
        }
    }, [selectedSus]);

    const handleRangeFromChange = (date) => {
        setFromRange(date);
    };

    const handleRangeToChange = (date) => {
        setToRange(date);
    };

    const handleListRefresh = () => {
        setRefetch(refetch => refetch + 1);
    };

    const handleSpendChange = (value) => {
        setSpend(value);
    };

    const handleExcludeChange = (e) => {
        setExcluded(e.target.value);
    };

    const handleImportUsers = () => {
        document.getElementById('importUsers').click();
    };

    useEffect(() => {
        if (spend > 0) {
            let price = spend.toString().replace(/^0+/, '');
            price = price.replace(/[\.\%]/g, function (match, offset, all) {
                return match === "." ? (all.indexOf(".") === offset ? '.' : '') : '';
            });
            setSpend(toFixedTrunc(parseFloat(price), 2));
        }
    }, [spend]);

    const handleUsersImport = (e) => {
        Papa.parse(e.target.files[0], {
            fields: ['id', 'username'],
            header: false,
            skipEmptyLines: true,
            complete: function (results) {
                let tmp = [];
                if (results.data.length > 0) {
                    results.data.forEach(item => {
                        tmp.push(`${item[0]},${item[1]}`);
                    });
                }
                setExcluded(tmp.join('\n'));
            },
        });
    };

    const handleRemoveList = () => {
        setRemoveCount(removeCount => removeCount + 1);
    };

    const handleFirstSubscriptionChange = (date) => {
        setFirstSubscription(date);
    };



    return <div className="creator-sales-boost">
        <h3 className="mb-4">Add New Followers to a Creator</h3>

        <div className="row">
            <div className="col-xs-12 col-sm-12 col-filters">
                <div className="filters">
                    <label className="filters__label">Search List Users</label>

                    <div className="row">
                        <div
                            className={`col-md-3 filters__form ${selectedPusError ? 'has-error' : ''}`}
                        >
                            <PuSearch
                                selectedPus={selectedPus}
                                setSelectedPus={setSelectedPus}
                            />
                            {
                                selectedPusError && <div className='error' style={{ fontSize: '12px !important' }}>
                                    {selectedPusError}
                                </div>
                            }

                            <div className="my-2">
                                <AddOptions
                                    setSubscriptionPrice={setSubscriptionPrice}
                                    subscriptionPrice={subscriptionPrice}
                                    setPlanName={setPlanName}
                                    planName={planName}
                                    status={status}
                                    setStatus={setStatus}
                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className='add-sus-container'>
                                <div className="row">
                                    <div className="col-md-7">
                                        <label className="add-sus-container-label">Add SUs to follow</label>

                                        <div className='filters__payment-range'>
                                            <label>
                                                Last Payment Range
                                            </label>
                                            <div className='filters__payment-range-form'>
                                                <ReactDatePicker
                                                    selected={fromRange}
                                                    onChange={handleRangeFromChange}
                                                    dateFormat="dd MMM yy"
                                                    maxDate={toRange || new Date()}
                                                />
                                                {' '} to {' '}
                                                <ReactDatePicker
                                                    selected={toRange}
                                                    onChange={handleRangeToChange}
                                                    dateFormat="dd MMM yy"
                                                    maxDate={new Date()}
                                                    minDate={fromRange}
                                                />
                                            </div>
                                        </div>
                                        <div className="filters__first_subs">
                                            <label htmlFor="spend">First Subscription ></label>
                                            <ReactDatePicker
                                                selected={firstSubscription}
                                                onChange={handleFirstSubscriptionChange}
                                                dateFormat="dd MMM yy"
                                                maxDate={new Date()}
                                            />
                                        </div>
                                        <div className="filters__spend">
                                            <label htmlFor="spend">Total USD Spend ></label>
                                            <DecimalInput
                                                id="spend"
                                                value={spend}
                                                handleChange={handleSpendChange}
                                                className="col-md-4"
                                            />
                                        </div>

                                        <div className="mt-3">
                                            <button
                                                className="btn btn-primary"
                                                onClick={handleListRefresh}
                                                disabled={isBusy}
                                            >
                                                {
                                                    isBusy ? 'Loading...' : 'Load draft list'
                                                }
                                            </button>
                                        </div>
                                    </div>

                                    <div className="col-md-5">
                                        <div className="mb-2">
                                            <PuLookup
                                                puFollowersToInclude={puFollowersToInclude}
                                                setPuFollowersToInclude={setPuFollowersToInclude}
                                            />
                                        </div>
                                        <div className="my-1">
                                            <SuLookup
                                                suToInclude={suToInclude}
                                                setSuToInclude={setSuToInclude}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 filters__exclude-container">
                            <div className='filters__exclude'>
                                <label htmlFor="exclude">Excluding SUs</label>
                                <textarea
                                    name="exclude"
                                    id="exclude"
                                    rows="5"
                                    value={excluded}
                                    onChange={handleExcludeChange}
                                />
                                <input
                                    type="file"
                                    accept=".csv"
                                    id="importUsers"
                                    hidden
                                    onChange={handleUsersImport}
                                />
                                <div className="actions">
                                    <button
                                        className="btn btn-primary"
                                        onClick={handleImportUsers}
                                    >
                                        IMPORT USERS
                                    </button>

                                    <button
                                        className="btn btn-primary"
                                        onClick={handleRemoveList}
                                        disabled={isBusy}
                                    >
                                        REMOVE FROM LIST
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-7">
                <SuList
                    selectedSus={selectedSus}
                    setSelectedSus={setSelectedSus}
                    fromRange={fromRange}
                    toRange={toRange}
                    setRefetch={setRefetch}
                    refetch={refetch}
                    spend={spend}
                    setIsBusy={setIsBusy}
                    exportCSV={exportCSV}
                    setExportCSV={setExportCSV}
                    excluded={excluded}
                    selectedPus={selectedPus}
                    suToInclude={suToInclude}
                    setSuToInclude={setSuToInclude}
                    selectedSUsObject={selectedSUsObject}
                    setSelectedSUsObject={setSelectedSUsObject}
                    setMainList={setMainList}
                    mainList={mainList}
                    puFollowersToInclude={puFollowersToInclude}
                    setPuFollowersToInclude={setPuFollowersToInclude}
                    removeCount={removeCount}
                    firstSubscription={firstSubscription}
                />
            </div>
            <div className="col-sm-12 col-md-12 col-lg-5">
                <MainList
                    setMainList={setMainList}
                    mainList={mainList}
                    handleAddFollowers={handleAddFollowers}
                    suToAdd={suToAdd}
                    setSuToAdd={setSuToAdd}
                    evalMainList={evalMainList}
                    setEvalMainList={setEvalMainList}
                    isBusy={isAdding}
                />
            </div>
        </div>

        <PAlert
            show={showAlert}
            setShow={setShowAlert}
            body={selectedSusError}
            onClose={handleCloseAlert}
            bodyStyle={{ textAlign: 'center' }}
            footerStyle={{ justifyContent: 'center' }}
        />
    </div>;
};

export default CreatorSalesBoost;
